import type { Parceiro } from "./tipos"

// Benup (benup.com.br), hub de benefícios corporativos que leva o consignado aos clientes dela. Cores
// e fonte tiradas do site deles: o verde-escuro nas superfícies com o texto em verde-limão, como os
// botões deles.
//
// O neutro dos gráficos é o azul da Faz Cred, e não um verde da marca: verde é desfecho bom, e na
// rosca da margem "margem livre" fica ao lado de "até metade tomada" — dois verdes viram a mesma
// fatia. A paleta da Benup não tem outra cor.
//
// Sem arquivo oficial do logo ainda: o nome vai escrito na fonte e na cor da marca.
export const BENUP: Parceiro = {
    slug: "benup",
    nome: "Benup",
    doParceiro: "da Benup",
    comArtigo: "a Benup",
    tituloDaAba: "Benup · Portal do Empregador",
    marca: { tipo: "texto", texto: "benup" },
    dominios: [],
    operadoPelaFazCred: true,
    tema: {
        claro: {
            brand: "#22420d",
            "brand-ink": "#97ec5f",
            "brand-strong": "#17300a",
            "brand-wash": "#e4f9d3",
            data: "#1e50ff",
            page: "#f6fff0",
            card: "#ffffff",
            sunk: "#edf7e6",
            ink: "#22420d",
            soft: "#33402b",
            faint: "#5f6b58",
            line: "#e2ecd9",
            "line-strong": "#c5d4b8",
        },
        escuro: {
            brand: "#97ec5f",
            "brand-ink": "#10190a",
            "brand-strong": "#b5f38c",
            "brand-wash": "#213a12",
            data: "#6b8cff",
            page: "#0c120a",
            card: "#141c10",
            sunk: "#1d2818",
            ink: "#effae8",
            soft: "#d9e6d0",
            faint: "#a9b8a0",
            line: "#26331f",
            "line-strong": "#3b4a32",
        },
    },
    fontes: {
        titulo: '"Sora Variable", ui-sans-serif, system-ui, sans-serif',
        texto: '"Sora Variable", ui-sans-serif, system-ui, sans-serif',
        numeros: '"Sora Variable", ui-sans-serif, system-ui, sans-serif',
        carregar: () => import("@fontsource-variable/sora"),
    },
}
